import {
  GET_INVENTORY_ITEMS_DATA,
  GET_INVENTORY_ITEMS_LOADER
} from "../../constants/ActionTypes";
import ds from "../../Services/DataServices";
import { message } from "antd";

 
export function loadInventoryTakesItemsData(loadValue) {
  return (dispatch) => {
    dispatch({ type: GET_INVENTORY_ITEMS_DATA, payload: loadValue });
  };
}
export function loadIsInventoryTakesItemsLoading(loadValue) {
  return (dispatch) => {
    dispatch({ type: GET_INVENTORY_ITEMS_LOADER, payload: loadValue });
  };
}

 
 
 